import { Flame, Leaf } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';

export default function MenuItem({ item, onClick }) {
  return (
    <Card 
      className="cursor-pointer hover:shadow-lg transition-shadow duration-200 bg-white"
      onClick={() => onClick(item)}
    >
      <CardContent className="p-0">
        <div className="flex gap-3 p-3">
          {/* Image */}
          <div className="h-24 w-24 md:h-28 md:w-28 rounded-lg overflow-hidden flex-shrink-0 bg-gray-100">
            {item.image_url ? (
              <img 
                src={item.image_url} 
                alt={item.name}
                className="h-full w-full object-cover"
                loading="lazy"
              />
            ) : (
              <div className="h-full w-full flex items-center justify-center text-4xl">
                🍽️
              </div>
            )}
          </div>
          
          {/* Content */}
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0 flex-1">
                <h3 className="font-semibold text-gray-900 text-base md:text-lg line-clamp-1">
                  {item.name}
                </h3>
                
                {item.description && (
                  <p className="text-sm text-gray-600 mt-1 line-clamp-2">
                    {item.description}
                  </p>
                )}
                
                {/* Dietary Badges */}
                {(item.is_spicy || item.is_vegetarian || item.is_vegan || item.is_gluten_free) && (
                  <div className="flex items-center gap-1.5 mt-2 flex-wrap">
                    {item.is_spicy && (
                      <Badge variant="outline" className="text-red-600 border-red-300 text-xs">
                        <Flame className="h-3 w-3 mr-1" />
                        Spicy
                      </Badge>
                    )}
                    {item.is_vegetarian && (
                      <Badge variant="outline" className="text-green-600 border-green-300 text-xs">
                        <Leaf className="h-3 w-3 mr-1" />
                        Vegetarian
                      </Badge>
                    )}
                    {item.is_vegan && (
                      <Badge variant="outline" className="text-green-700 border-green-400 text-xs">
                        Vegan
                      </Badge>
                    )}
                    {item.is_gluten_free && (
                      <Badge variant="outline" className="text-xs">
                        GF
                      </Badge>
                    )}
                  </div>
                )}
              </div>
            </div>
            
            {/* Price & Meta */}
            <div className="flex items-center justify-between mt-2">
              <span className="text-lg md:text-xl font-bold text-blue-600">
                ${item.price.toFixed(2)}
              </span>
              
              <div className="flex items-center gap-2 text-xs text-gray-500">
                {item.is_popular && (
                  <Badge className="bg-yellow-500 hover:bg-yellow-600 text-xs">
                    Popular
                  </Badge>
                )}
                {item.calories && (
                  <span>{item.calories} cal</span>
                )}
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
